<template>
  <div>
    <div class="prove-images" v-if="previewPictures && previewPictures.length>0">
      <div v-for="item in previewPictures" class="thumbnail" @click="viewLarge($event)" :style="{backgroundImage: 'url('+item+')'}"></div>
    </div>
    <div class="large-box" v-if="showLarge" @click="viewLarge">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide swiper-item" v-for="item in largeImageList" :style="item"></div>
        </div>
      </div>
      <div class="page-num">{{pictureIndex}} / {{pictureTotal}}</div>
    </div>
  </div>
</template>

<script>

  import Swiper from '../assets/js/swiper-3.4.2.min.js'

  export default {
    props: ['previewPictures'],
    data () {
      return {
        largeImageList: [],
        pictureTotal: '',
        pictureIndex: '',
        showLarge: false,
      }
    },
    methods: {
      viewLarge: function (e) {
        var _this = this
        var imageList = []
        var list = e.target.parentNode.childNodes
        var defaultIndex;
        for(var i=0;i<list.length;i++) {
          if(list[i] == e.target) {
            _this.pictureIndex = i+1
            defaultIndex = i
          }
          var obj = {}
          obj.backgroundImage = list[i].style.backgroundImage
          imageList.push(obj)
        }
        _this.pictureTotal = list.length
        _this.largeImageList = imageList
        _this.showLarge = !_this.showLarge
        _this.$nextTick(function () {
          var mySwiper = new Swiper('.swiper-container',{
            watchActiveIndex : true,
            initialSlide : defaultIndex,
            onSlideChangeEnd: function(swiper){
              _this.pictureIndex = swiper.activeIndex + 1
            }
          })
        })
      }
    }
  }
</script>
<style scoped>
  .swiper-item{
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center;
  }
</style>



// WEBPACK FOOTER //
// PreviewPicture.vue?1dfef3ef